import { render } from "./OutlayRow.vue?vue&type=template&id=2db9270b&scoped=true"
import script from "./OutlayRow.vue?vue&type=script&lang=js"
export * from "./OutlayRow.vue?vue&type=script&lang=js"

import "./OutlayRow.vue?vue&type=style&index=0&id=2db9270b&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db9270b"]])

export default __exports__